import React from 'react';
import PropTypes from 'prop-types';

const EffectFreehandPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M15.927 21.69c-.798 2.363-.373 3.84.597 3.84 2.51 0 3.989-4.696 3.632-8.46-1.86.548-3.45 2.312-4.23 4.62zm6.586 1.193c-.96 3.43-2.922 5.646-5.989 5.646-3.696 0-4.791-3.798-3.44-7.799 1.063-3.144 3.305-5.66 6.14-6.52-.462-.83-1.035-1.606-1.526-1.933-.965-.643-2.076-.643-2.686-.114-.898.778-1.535 1.895-2.68 4.47l-.127.284c-1.057 2.378-1.626 3.46-2.527 4.532-.624.743-1.454 1.346-2.364 1.554-1.404.32-2.684-.36-3.422-1.855-1.054-2.132-.77-3.971.607-8.332.882-2.797 1.15-3.998 1.038-5.142-.019-.193-.13-.324-.42-.465a2.36 2.36 0 0 0-.738-.214 1.5 1.5 0 1 1 .243-2.99c.486.04 1.129.178 1.802.504 1.155.56 1.967 1.515 2.1 2.875.165 1.705-.15 3.12-1.151 6.292-1.129 3.577-1.35 5.012-.792 6.144.057.115.104.19.136.235.182-.075.453-.285.665-.536.654-.778 1.143-1.71 2.082-3.82l.127-.285c1.331-2.994 2.102-4.344 3.457-5.518 1.693-1.467 4.283-1.469 6.314-.115 1.2.8 2.37 2.523 3.064 4.141 3.91.247 6.057 1.98 6.057 6.48 0 .804-.223 1.587-.604 2.348a1.5 1.5 0 1 1-2.682-1.345c.188-.374.286-.719.286-1.002 0-2.247-.599-3.125-2.343-3.403.096 1.75-.105 4.013-.627 5.883z"
    />
  );
};

EffectFreehandPath.propTypes = {
  fill: PropTypes.string,
};

export default EffectFreehandPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/effects/effect-freehand.jsx